import { TEXT_LABELS as labels } from 'playable/dist/src/constants';
import translations from 'messages/widget';
import i18n from '@wix/wix-vod-shared/src/common/i18n';

export default () => ({
  [labels.LOGO_LABEL]: i18n.t(translations.watchOnSiteLabel),
  [labels.LOGO_TOOLTIP]: i18n.t(translations.watchOnSiteTooltip),
  [labels.PAUSE_CONTROL_LABEL]: i18n.t(translations.pauseControlLabel),
  [labels.PLAY_CONTROL_LABEL]: i18n.t(translations.playControlLabel),
  [labels.PROGRESS_CONTROL_LABEL]: i18n.t(translations.progressControlLabel),
  [labels.PROGRESS_CONTROL_VALUE]: ({ percent = 0 }) =>
    i18n.t(translations.progressControlValue, { percent }),
  [labels.MUTE_CONTROL_LABEL]: i18n.t(translations.muteControlLabel),
  [labels.MUTE_CONTROL_TOOLTIP]: i18n.t(translations.muteControlTooltip),
  [labels.UNMUTE_CONTROL_LABEL]: i18n.t(translations.unmuteControlLabel),
  [labels.UNMUTE_CONTROL_TOOLTIP]: i18n.t(translations.unmuteControlTooltip),
  [labels.VOLUME_CONTROL_LABEL]: i18n.t(translations.volumeControlLabel),
  [labels.VOLUME_CONTROL_VALUE]: ({ volume = 0 }) =>
    i18n.t(translations.volumeControlValue, { percent: volume }),
  [labels.ENTER_FULL_SCREEN_LABEL]: i18n.t(translations.enterFullScreenLabel),
  [labels.ENTER_FULL_SCREEN_TOOLTIP]: i18n.t(translations.enterFullScreenTooltip),
  [labels.EXIT_FULL_SCREEN_LABEL]: i18n.t(translations.exitFullScreenLabel),
  [labels.EXIT_FULL_SCREEN_TOOLTIP]: i18n.t(translations.exitFullScreenTooltip),
  [labels.LIVE_INDICATOR_TEXT]: ({ isEnded }) =>
    (isEnded ? i18n.t(translations.liveEndedIndicator) : i18n.t(translations.liveIndicator)),
  [labels.LIVE_SYNC_LABEL]: i18n.t(translations.liveSyncLabel),
  [labels.LIVE_SYNC_TOOLTIP]: i18n.t(translations.liveSyncTooltip),
});



// WEBPACK FOOTER //
// ./src/shared/utils/get-player-translations.js